import { render, staticRenderFns } from "./ActivityStoryImage.vue?vue&type=template&id=1df5bfdc&scoped=true"
import script from "./ActivityStoryImage.vue?vue&type=script&lang=ts"
export * from "./ActivityStoryImage.vue?vue&type=script&lang=ts"
import style0 from "./ActivityStoryImage.vue?vue&type=style&index=0&id=1df5bfdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df5bfdc",
  null
  
)

export default component.exports